/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'building/shipyard_3_orbital': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" d="M19 7l-3 6-3-6z"/><path pid="1" d="M12 7l4 8.572L20 7h3l-7 14L9 7z"/><path pid="2" d="M8 7l8 16 8-16h2L15.985 27 6 7zM20 5h3v1h-3zM13 4h6v2h-6zM9 5h3v1H9z"/><path pid="3" d="M10 19H9v-6l1 2zM23 19h-1v-4l1-2zM15 32H0V17h1v14h14zM32 32H17v-1h14V17h1zM32 15h-1V1H17V0h15zM1 15H0V0h15v1H1z"/>'
  }
})
